import React from "react";
import { Box, Grid, Typography } from "@mui/material";
import PressReleases from "../../../../pages/primary/resources/PressReleases";

function Resources() {
  return (
    <Box
      sx={{
        height: "100%",
        display: "flex",
        gap: { xs: 1, md: 3 },
        flexDirection: "column",
        justifyContent: "start",
        alignItems: "start",
      }}
    >
      <Typography variant="h5" sx={{ ml: 1, mt: 2 }}>
        Resources
      </Typography>

      <Box sx={{ ml: 2, width: '100%', display: 'flex', flexDirection: 'column', gap: 0.5, }} >
        <Typography sx={{ fontSize: '0.9rem' }} >Market Reports</Typography>
        <Typography sx={{ fontSize: '0.9rem' }} >Company Profile</Typography>
        <Typography sx={{ fontSize: '0.9rem' }} >Industries</Typography>
        <Typography sx={{ fontSize: '0.9rem' }} >Articles</Typography>
        <Typography sx={{ fontSize: '0.9rem' }} >Press Releases</Typography>
        <Typography sx={{ fontSize: '0.9rem' }} >Recent Developments</Typography>
        <Typography sx={{ fontSize: '0.9rem' }} >Case Study</Typography>
      </Box>
    </Box>
  );
}

export default Resources;
